/* eslint strings-must-be-singlequote: 0 */ // --> OFF
/* eslint-disable */
import languages from '../languages';
import errorMessages from './errorMessages';
import accessibility from './accessibility';
import ui from './ui';
import dates from './dates';

export default Object.keys(languages).reduce(
	(acc, key) =>
		Object.assign(acc, {
			[key]: Object.assign({}, ui[key], dates[key], errorMessages[key], accessibility[key]),
		}),
	{}
);
